import React from 'react';
import type { UserLimitStatus } from '../../services/api/users';

interface UserLimitWarningProps {
  status: UserLimitStatus;
}

const UserLimitWarning: React.FC<UserLimitWarningProps> = ({ status }) => {
  if (!status.hasWarning && !status.isAtLimit) {
    return null;
  }

  return (
    <div
      className={`rounded-lg p-4 ${
        status.isAtLimit
          ? 'bg-red-50 border border-red-200'
          : 'bg-yellow-50 border border-yellow-200'
      }`}
    >
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg
            className={`h-5 w-5 ${
              status.isAtLimit ? 'text-red-400' : 'text-yellow-400'
            }`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3
            className={`text-sm font-medium ${
              status.isAtLimit ? 'text-red-800' : 'text-yellow-800'
            }`}
          >
            {status.isAtLimit ? 'Límite de usuarios alcanzado' : 'Cerca del límite de usuarios'}
          </h3>
          <div
            className={`mt-2 text-sm ${
              status.isAtLimit ? 'text-red-700' : 'text-yellow-700'
            }`}
          >
            <p>
              Tienes {status.activeUsers} de {status.maxUsers} usuarios activos (
              {status.percentage}%).
            </p>
            {status.isAtLimit ? (
              <p className="mt-1">
                No puedes crear más usuarios. Por favor, actualiza tu plan para agregar más usuarios.
              </p>
            ) : (
              <p className="mt-1">
                Te quedan {status.availableSlots} espacio{status.availableSlots !== 1 ? 's' : ''}{' '}
                disponible{status.availableSlots !== 1 ? 's' : ''}.
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserLimitWarning;
